import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import {
  AgentDto,
  useCampaignControllerCampaignQuery,
} from '@shared/services/apiService/apiService';
import { AgentList } from './components/AgentList';
import Spinner from '@shared/components/spinner/Spinner';
import { Box } from '@mui/material';
import AgentSection from './components/AgentSection';

interface AgentPageProps {
  isLoading: boolean;
  refetch: () => Promise<void>;
  onAgentCreated?: () => Promise<void>;
  agents: AgentDto[];
  isProductDetailsDirty: boolean;
  isSavingProductDetails: boolean;
  onProductDetailsSave: () => Promise<boolean>;
  onProductDetailsCancel: () => void;
}

export const AgentPage: React.FC<AgentPageProps> = ({
  agents: agentList,
  refetch,
  onAgentCreated,
  isLoading,
  isProductDetailsDirty,
  isSavingProductDetails,
  onProductDetailsSave,
  onProductDetailsCancel,
}) => {
  const [loadingFlag, setLoadingFlag] = useState(false);
  const { campaignId } = useParams();

  const { data: campaignData, isLoading: isCampaignLoading } = useCampaignControllerCampaignQuery(
    { id: campaignId || '' },
    { skip: !campaignId },
  );

  const squad = campaignData?.squad;
  const isSquad = !!squad;
  const squadName = squad?.name || null;

  const displayAgents = isSquad && squad?.agents ? squad.agents : agentList;

  const setLoading = async (flag: boolean) => {
    await refetch();
    setLoadingFlag(flag);
  };

  if (isLoading || loadingFlag || isCampaignLoading) {
    return <Spinner />;
  }

  return (
    <>
      <AgentList
        onRefresh={refetch}
        onAgentCreated={onAgentCreated}
        setLoading={setLoading}
        agentList={displayAgents || []}
        isSquad={isSquad}
        campaignData={campaignData}
      />

      <Box mt={4}>
        <AgentSection
          isSquad={isSquad}
          squadName={squadName}
          campaignId={campaignId}
          onSquadDeleted={refetch}
          isProductDetailsDirty={isProductDetailsDirty}
          isSavingProductDetails={isSavingProductDetails}
          onProductDetailsSave={onProductDetailsSave}
          onProductDetailsCancel={onProductDetailsCancel}
        />
      </Box>
    </>
  );
};
